export default "__VITE_ASSET__C2MB_tE___"